import React, { useState, useEffect } from 'react';
import { Button } from '@shopify/polaris';
import { ArrowUpMinor } from '@shopify/polaris-icons';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            cursor: 'pointer',
            backgroundColor: 'transparent',
          }}
        >
          <Button
            icon={ArrowUpMinor}
            onClick={scrollToTop}
            primary
            accessibilityLabel="Scroll to top"
          />
        </div>
      )}
    </>
  );
};

export default ScrollToTop;
